module.exports = __webpack_public_path__ + "static/media/13.31285662.png";